import React, { useEffect, useState } from 'react';
import './ClientRetentionScore.css';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import RadialSeparators from './RadialSeparators';


const ClientRetentionScore = ({ score }) => {
    if (score === null || score === undefined) return <div>No score available</div>;

    const calculateColor = (value) => {
        if (value >= 7) return { label: 'Great', color: '#03BC72' }; // Green
        if (value >= 5) return { label: 'Good', color: '#F6A637' }; // Orange
        return { label: 'At Risk', color: '#F52B53' }; // Red
    };

    const adjustedScore = (() => {
        if (score >= 10) return 10;
        if (score >= 7.5) return 7.5;
        if (score >= 5) return 5;
        if (score >= 2.5) return 2.5;
        return 0;
    })();

    const retentionData = calculateColor(adjustedScore);

    return (
        <div className="retention-score-container">
            <h2>Client Retention Score</h2>
            <p>Shows the average Client Retention Score across all clients.</p>
            <div className="retention-chart">
                <CircularProgressbarWithChildren
                    value={adjustedScore}
                    maxValue={10}
                    circleRatio={0.5}
                    text={`${score.toFixed(2)}`}
                    styles={buildStyles({
                        textColor: '#291B3B',
                        textSize: '24px',
                        pathColor: retentionData.color,
                        trailColor: '#EDECFD',
                        strokeLinecap: 'butt',
                        rotation: 0.75,
                    })}
                >
                    <RadialSeparators
                        count={4}
                        circleRatio={0.5}
                        style={{
                            background: '#fff',
                            width: '2px',
                            height: '10%',
                        }}
                    />
                </CircularProgressbarWithChildren>

                <div className="retention-label">
                    <span style={{ color: retentionData.color }}>{retentionData.label}</span>
                </div>
            </div>
        </div>
    );
};

export default ClientRetentionScore;
